import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody,
  ModalCloseButton, Button, FormControl, FormLabel, Select, Textarea, Switch, useToast
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { updateOrgAIInstruction, createOrgAIInstruction } from "../../hooks/ai_instructions";

const contextOptions = [
  "general",
  "customer_support",
  "product_inquiry",
  "delivery_update",
  "sales_pitch",
  "technical_support",
];

export default function InstructionModal({ isOpen, onClose, orgId, existing, onSaved }: any) {
  const toast = useToast();
  const [context, setContext] = useState(existing?.context_type || "general");
  const [text, setText] = useState(existing?.instruction_text || "");
  const [active, setActive] = useState(existing?.active ?? true);
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    try {
      const payload = { context_type: context, instruction_text: text, active };
      const res = existing
        ? await updateOrgAIInstruction(orgId, existing.id, payload)
        : await createOrgAIInstruction(orgId, payload);

      if (res.success) {
        toast({ title: "Instruction saved", status: "success" });
        onSaved();
        onClose();
      }
    } catch {
      toast({ title: "Error saving instruction", status: "error" });
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    setContext(existing?.context_type || "general");
    setText(existing?.instruction_text || "");
    setActive(existing?.active ?? true);
  }, [existing]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{existing ? "Edit Instruction" : "Add Instruction"}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl mb={4}>
            <FormLabel>Context Type</FormLabel>
            <Select value={context} onChange={(e) => setContext(e.target.value)}>
              {contextOptions.map((opt) => (
                <option key={opt} value={opt}>
                  {opt.replace("_", " ").toUpperCase()}
                </option>
              ))}
            </Select>
          </FormControl>
          <FormControl mb={4}>
            <FormLabel>Instruction Text</FormLabel>
            <Textarea
              value={text}
              onChange={(e) => setText(e.target.value)}
              placeholder="Write AI behavior or tone instructions here..."
            />
          </FormControl>
          <FormControl display="flex" alignItems="center">
            <FormLabel mb="0">Active</FormLabel>
            <Switch isChecked={active} colorScheme={"green"} onChange={(e) => setActive(e.target.checked)} />
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button colorScheme="green" bg={"#006400"} isLoading={saving} onClick={handleSave}>
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
